import Alpine from 'alpinejs';

Alpine.data('cycleComponent', (duration = 4000, total = 0, isGallery = false) => ({
  active: 0,
  cyclestyle: '',
  duration,
  total,
  _interval: null,
  _timeout: null,

  start() {
    this.destroy();

    this._timeout = setTimeout(() => {
      this.cyclestyle = isGallery ? 'cycle-gallery' : 'cycle-standard';
    }, 700);

    this._interval = setInterval(() => {
      this.nextSlide();
    }, this.duration);
  },

  destroy() {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  },

  nextSlide() {
    this.active = this.active === this.total ? 0 : this.active + 1;
  }
}));
